import { render, staticRenderFns } from "./scoresOnly.vue?vue&type=template&id=1aad7104&scoped=true"
import script from "./scoresOnly.vue?vue&type=script&lang=js"
export * from "./scoresOnly.vue?vue&type=script&lang=js"
import style0 from "./scoresOnly.vue?vue&type=style&index=0&id=1aad7104&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aad7104",
  null
  
)

export default component.exports